export function formatDuration(hours: number | null): string {
  if (hours === null || hours === undefined || Number.isNaN(hours) || hours < 0) return "—";
  const h = Math.floor(hours);
  const m = Math.round((hours - h) * 60);
  if (h === 0) return `${m}m`;
  return `${h}h ${m}m`;
}

